import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null,
};

const clientTrendReducer = createReducer(initialState, {
  CLIENT_TREND_REQ: (state) => {
    state.loading = true;
    state.user = null;
  },
  CLIENT_TREND_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  CLIENT_TREND_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = {};
  },
});

export default clientTrendReducer;
